module.exports = __webpack_public_path__ + "static/dynamic-1fdc041e55a38a99f5519d3e109b9c6b.png";